/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientComms/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PatientComms({
  children,
  viewPath = "/DesignSystem/PatientComms"
  
}) {
  return (<React.Fragment
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</React.Fragment>)
}